export const MASTER_NAME_MAX_LENGTH = 50
export const MASTER_LIMIT = 50
